<template>
 <div class="UserResponseList">
    <div class="container-fluid padding-right-0Perc padding-left-0Perc margin-left-2Point9Perc margin-right-2Point2Perc">
      <div class="table-responsive margin-Top-3Perc">
        <table class="table table-striped ">
          <thead>
            <tr>
              <th class="text-align-center text-valign-middle font-size-15px border-right">User</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Response Video</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Response Text</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">State</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Score</th>
              <!-- <th class="text-align-center text-valign-middle font-size-15px border-right">Submit TS</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Allocated Count</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Max Allocation TS</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Max Feedback Submit TS</th>
              <th class="text-align-center text-valign-middle font-size-15px">Updated TS</th>            
            -->
              <th class="text-align-center text-valign-middle font-size-15px">Action</th>
            </tr> 
          </thead>
          <tbody>
            <tr v-for="user in userDetails" :key="user.userId" v-bind:userObj = "user" > 
              <td class="text-align-center text-valign-middle border-right">{{user.userName}}</td>
              <td class="text-align-center text-valign-middle border-right">
                <video width="200" height="80" controls controlsList="nodownload">
                   <source v-bind:src="user.responseVideo" type="video/mp4">
                   <source v-bind:src= "user.responseVideo" type="video/ogg">
                </video>
              </td>
              <td class="text-align-center text-valign-middle border-right">{{user.responseText}}</td>
              <td class="text-align-center text-valign-middle border-right">{{user.state}}</td>
              <td class="text-align-center text-valign-middle border-right">{{user.score}}</td>
              <!-- <td class="text-align-center text-valign-middle border-right">{{user.submitTS}}</td>
              <td class="text-align-center text-valign-middle border-right">{{user.allocatedCount}}</td>
              <td class="text-align-center text-valign-middle border-right">{{user.maxAllocationTS}}</td>
              <td class="text-align-center text-valign-middle border-right">{{user.maxFeedbackSubmitTS}}</td>
              <td class="text-align-center text-valign-middle">{{user.updatedTS}}</td>
               -->
               <td class="text-align-center text-valign-middle col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <a href="#"> View </a>|
                <a href="#"> Delete </a>|
                <a href="#"> Feedback Given </a>|
                <a href="#"> Feedback Received</a>
              </td>
            </tr>
          </tbody>
       </table>
      <!--</div>-->
     <!--</div>-->
    </div><!--end of group table -->
    </div>
  </div>
 
</template>
<script>
export default {
  data: function () {
    return {
      userDetails: [
        {
          userId: 1,
          userName: 'Kraft Heins',
          responseVideo: 'https://youtu.be/An2OaIbPSII',
          responseText: 'Lorem Ipsum is simply dummy text',
          state: 'Feedback Submitted',
          score: '30',
          submitTS: '11/17/2017 4:14:02 AM',
          allocatedCount: '2',
          maxAllocationTS: '23',
          maxFeedbackSubmitTS: '34',
          updatedTS: '56',
          isSelected: false
        },
        {
          userId: 2,
          userName: 'Aaron Hank',
          responseVideo: 'https://youtu.be/An2OaIbPSII',
          responseText: 'Lorem Ipsum is simply dummy text',
          state: 'Response Submitted',
          score: '221',
          submitTS: '12/15/2017 2:17:09 AM',
          allocatedCount: '2',
          maxAllocationTS: '23',
          maxFeedbackSubmitTS: '34',
          updatedTS: '56',
          isSelected: false
        },
        {
          userId: 3,
          userName: 'Abagnale Frank',
          responseVideo: 'https://youtu.be/An2OaIbPSII',
          responseText: 'Lorem Ipsum is simply dummy text',
          state: 'Response Submitted',
          score: '221',
          submitTS: '12/15/2017 2:17:10 AM',
          allocatedCount: '2',
          maxAllocationTS: '23',
          maxFeedbackSubmitTS: '34',
          updatedTS: '56',
          isSelected: false
        },
        {
          userId: 4,
          userName: 'Abbey Edward',
          responseVideo: 'https://youtu.be/An2OaIbPSII',
          responseText: 'Lorem Ipsum is simply dummy text',
          state: 'Feedback Submitted',
          score: '221',
          submitTS: '12/15/2017 2:17:18 AM',
          allocatedCount: '2',
          maxAllocationTS: '23',
          maxFeedbackSubmitTS: '34',
          updatedTS: '56',
          isSelected: false
        }
      ]
    }
  }
}
</script>

<style scoped>
.UserResponseList {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.border-right
 {
   border-right: 1px solid #aaa !important;
 }
 .margin-Top-1Perc
{
	margin-top: 1%;
}
.margin-Top-3Perc{
	margin-top: 3%;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
  .table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
 }
 .text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
.text-valign-middle{
  vertical-align: middle;
}
.padding-right-0Perc{
  padding-right:0% !important;
}
.padding-left-0Perc{
  padding-left:0% !important;
}
.margin-left-1Perc{
  margin-left:1% !important;
}
.margin-left-2Point9Perc{
  margin-left:2.9% !important;  
}
.margin-right-2Point9Perc{
  margin-right:2.9% !important;  
}
.margin-right-2Point2Perc{
  margin-right:2.2% !important;  
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/UserResponseList.vue